/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { Link } from '@insticator/insticator-ui'; // iui-material



/* ========== ~~~~~~~~~~ CTA : EDIT EMBED ~~~~~~~~~~ ========== */
class EditEmbedCTA extends Component {
  constructor(props) {
    super(props);
    this.state = { processing: false };
  }
  componentDidUpdate(prevProps) {
    if(!this.props.currentPage && prevProps.currentPage) { this.setState({ processing: false }) }
  }
  handleUUID = () => this.props.selectedUUID ? this.props.selectedUUID : this.props.embedUUID;
  render() {
    return(
        <Link
               type={`action`}
               text={`Edit Embed`}
               color={this.props.color ? this.props.color : `primary`}
               action={() => this.props.editEmbed(this.handleUUID())}
               name={`editembed`}
               icon={`edit`}
               handleClick={() => this.setState({ processing: true })}
               operation={`load`}
               processing={this.state.processing}
        />
    );
  }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default EditEmbedCTA;
